import React, { useCallback } from 'react';
import { Button } from 'devextreme-react';
import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { useScreenSize } from '../../../utils/media-query';
import './PopupConfirmation.scss';
import { formatMessage } from 'devextreme/localization';

interface ConfirmationPopupProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  visible: boolean;
  width?: number;
  buttons?: 'No/Yes' | 'Cancel/Confirm';
  loading?: boolean;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({ message, onConfirm, onCancel, visible, width = 500, buttons = 'Cancel/Confirm', loading }) => {
  const { isXSmall, isSmall } = useScreenSize();

  const handleConfirm = useCallback(() => {
    onConfirm();
  }, [onConfirm]);

  const handleCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  return (
    <Popup height='auto' title={formatMessage('confirmationMessage')} fullScreen={isXSmall || isSmall} hideOnOutsideClick={false} width={width} visible={visible} dragEnabled={false} showTitle={true}>
      <h6>¿{message}?</h6>
      <ToolbarItem toolbar='bottom' location='after'>
        <div className={`form-popup-buttons-container ${width <= 360 ? 'flex-buttons' : ''}`}>
          {buttons === 'Cancel/Confirm' ? (
            <>
              <Button text='Cancelar' stylingMode='contained' onClick={handleCancel} />
              <Button text={loading ? 'Procesando...' : 'Confirmar'} disabled={loading} stylingMode='contained' type='default' onClick={handleConfirm} />
            </>
          ) : (
            <>
              <Button text='No' stylingMode='contained' onClick={handleCancel} />
              <Button text={loading ? 'Procesando...' : 'Sí'} disabled={loading} stylingMode='contained' type='default' onClick={handleConfirm} />
            </>
          )}
        </div>
      </ToolbarItem>
    </Popup>
  );
};

export default ConfirmationPopup;
